import { useState } from "react";
import HuggingFace from "./HuggingFace";
import FileUpload from "./FileUpload";
import GenerateDataset from "./GenerateDataset";

export default function UploadDatasets() {
  const [uploadType, setUploadType] = useState("generate"); // Default to HuggingFace
  
  return (
    <div className="max-w-5xl mx-auto px-4 py-8">
      <header className="mb-8">
        <h1 className="text-2xl md:text-3xl font-bold text-ktx-purple">
          Manage Training Datasets
        </h1>
        <p className="mt-2 text-gray-600">
          Import, upload, or generate training data for your fine-tuning jobs
        </p>
      </header>

      {/* Toggle between methods */}
      <div className="bg-white rounded-lg shadow-sm mb-8 p-4">
        <div className="flex flex-wrap items-center justify-center gap-2">
          {/* <button disabled
            onClick={() => setUploadType("huggingface")}
            className={`px-4 py-2 rounded-md transition-colors ${
              uploadType === "huggingface" 
                ? "bg-ktx-purple text-white font-medium" 
                : "bg-gray-100 text-gray-600 hover:bg-gray-200"
            }`}
          >
            <div className="flex items-center">
              <svg className="h-5 w-5 mr-1.5" viewBox="0 0 24 24" fill="currentColor">
                <path d="M10.53 10.73c-.1-.31-.19-.61-.29-.92-.1-.31-.19-.61-.28-.91-.09-.3-.18-.59-.27-.87-.09-.29-.17-.56-.25-.81h-.05c-.08.25-.16.52-.24.81l-.26.87c-.09.3-.18.6-.28.91-.1.31-.19.61-.3.92h2.22zm.93 2.49h-4.1l-.94 2.87h-2.3l3.9-11.14h2.8l3.9 11.14h-2.35l-.91-2.87z"/>
                <path d="M20.5 14.58h-2.1v2.15c0 .57.23.85.68.85.24 0 .44-.04.64-.12l.24 1.56c-.39.17-.93.26-1.6.26-1.83 0-2.73-.74-2.73-2.23v-2.47h-1.24v-1.69h1.24v-1.73h2.63v1.73h2.24v1.69z"/>
              </svg>
              HuggingFace Import
            </div>
          </button> */}
          {/* <button disabled
            onClick={() => setUploadType("upload")}
            className={`px-4 py-2 rounded-md transition-colors ${
              uploadType === "upload" 
                ? "bg-ktx-purple text-white font-medium" 
                : "bg-gray-100 text-gray-600 hover:bg-gray-200"
            }`}
          >
            <div className="flex items-center">
              <svg className="h-5 w-5 mr-1.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
              </svg>
              File Upload
            </div>
          </button> */}
          <button
            onClick={() => setUploadType("generate")}
            className={`px-4 py-2 rounded-md transition-colors ${
              uploadType === "generate" 
                ? "bg-ktx-purple text-white font-medium" 
                : "bg-gray-100 text-gray-600 hover:bg-gray-200"
            }`}
          >
            <div className="flex items-center">
              <svg className="h-5 w-5 mr-1.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
              </svg>
              Generate Dataset
            </div>
          </button>
        </div>
      </div>

      {/* Component container */}
      <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-100">
        {uploadType === "huggingface" && <HuggingFace />}
        {uploadType === "upload" && <FileUpload />}
        {uploadType === "generate" && <GenerateDataset />}
      </div>

      {/* Help section */}
      <div className="mt-8 bg-gray-50 rounded-lg p-6 border border-gray-100">
        <h3 className="text-lg font-semibold text-gray-800 mb-3">Data Preparation Guidelines</h3>
        
        <div className="grid md:grid-cols-3 gap-4 mt-4">
          <div className="bg-white p-4 rounded-md border border-gray-200">
            <h4 className="font-medium text-ktx-purple flex items-center">
              <svg className="h-5 w-5 mr-1.5" viewBox="0 0 24 24" fill="currentColor">
                <path d="M10.53 10.73c-.1-.31-.19-.61-.29-.92-.1-.31-.19-.61-.28-.91-.09-.3-.18-.59-.27-.87-.09-.29-.17-.56-.25-.81h-.05c-.08.25-.16.52-.24.81l-.26.87c-.09.3-.18.6-.28.91-.1.31-.19.61-.3.92h2.22zm.93 2.49h-4.1l-.94 2.87h-2.3l3.9-11.14h2.8l3.9 11.14h-2.35l-.91-2.87z"/>
                <path d="M20.5 14.58h-2.1v2.15c0 .57.23.85.68.85.24 0 .44-.04.64-.12l.24 1.56c-.39.17-.93.26-1.6.26-1.83 0-2.73-.74-2.73-2.23v-2.47h-1.24v-1.69h1.24v-1.73h2.63v1.73h2.24v1.69z"/>
              </svg>
              HuggingFace Import
            </h4>
            <ul className="mt-2 space-y-1 text-sm text-gray-600">
              <li>• Access thousands of public datasets</li>
              <li>• Perfect for well-known ML tasks</li>
              <li>• No data preparation required</li>
            </ul>
          </div>
          
          <div className="bg-white p-4 rounded-md border border-gray-200">
            <h4 className="font-medium text-ktx-purple flex items-center">
              <svg className="h-5 w-5 mr-1.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
              </svg>
              File Upload
            </h4>
            <ul className="mt-2 space-y-1 text-sm text-gray-600">
              <li>• Upload your own CSV data</li>
              <li>• Full control over training examples</li>
              <li>• Best for domain-specific tasks</li>
            </ul>
          </div>
          
          <div className="bg-white p-4 rounded-md border border-gray-200">
            <h4 className="font-medium text-ktx-purple flex items-center">
              <svg className="h-5 w-5 mr-1.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
              </svg>
              Generate Dataset
            </h4>
            <ul className="mt-2 space-y-1 text-sm text-gray-600">
              <li>• AI-assisted dataset creation</li>
              <li>• Create synthetic training examples</li>
              <li>• Expand existing datasets</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}